import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurveService{

  private curveSource = new BehaviorSubject({})
  currentCurve = this.curveSource.asObservable();
  constructor(private http: HttpClient) { }

  getGraphData(){
    return this.http.get<any>(environment.apiBaseUrl+'/user/graphGenerator')
  }

  getCurveData(){
    return this.http.get<any>(environment.apiBaseUrl+'/customer/get-curve-data')
  }

  getFilteredData(values){
    return this.http.post<any>(environment.apiBaseUrl+'/curveData/curveDataByFilter', values)
  }

  changeCurve(curve){
    this.curveSource.next(curve)
  }

  filterCurves(values){
    return this.http.post<any>(environment.apiBaseUrl+'/curveData/filterCurves', values)
  }

  getCurveDataById(id){
    return this.http.post<any>(environment.apiBaseUrl+'/curveData/curveDataById', id)
  }
}
